<template>
  <a-coursecard v-bind="$props">
    <template slot="actions" slot-scope="{}">
      <v-btn
        min-width="110px"
        color="grey"
        class="white--text"
        depressed
        :loading="loading"
        :disabled="loading"
        @click="$emit('delivery', course)"
        v-if="permissions.includes('distribution')"
        >Delivery</v-btn
      >
      <v-btn
        class="white--text"
        width="100"
        color="blue"
        depressed
        :loading="loading"
        :disabled="loading"
        @click="$emit('edit', course)"
        >Edit</v-btn
      >
      <v-spacer />
      <v-menu bottom offset-y left>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            @click="show = !show"
            v-on="on"
            v-if="permissions.includes('analyst')"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            @click="$emit('users', course)"
            class="item"
            v-if="permissions.includes('analyst')"
          >
            <v-list-item-icon
              ><v-icon>mdi-account-group-outline</v-icon></v-list-item-icon
            >

            <v-list-item-title class="text-center"
              >View Users</v-list-item-title
            >
          </v-list-item>
          <v-list-item
            @click="$emit('responses', course)"
            class="item"
            v-if="permissions.includes('analyst')"
          >
            <v-list-item-icon
              ><v-icon>mdi-message-text-outline</v-icon></v-list-item-icon
            >
            <v-list-item-title class="text-center"
              >View Responses</v-list-item-title
            >
          </v-list-item>
          <v-list-item
            @click="$emit('copy', course)"
            class="item"
            v-if="permissions.includes('writer')"
          >
            <v-list-item-icon
              ><v-icon>mdi-clipboard-text-outline</v-icon></v-list-item-icon
            >
            <v-list-item-title class="text-center"
              >Copy to Drafts</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </a-coursecard>
</template>
<style scoped>
.item {
  min-width: 150px;
}
</style>
<script>
import courseCard from "@/components/coursecard";

export default {
  components: {
    "a-coursecard": courseCard
  },
  props: ["course"],
  computed: {
    permissions() {
      if (Array.isArray(this.$store.getters.getUser.permissions)) {
        return this.$store.getters.getUser.permissions;
      } else {
        return [];
      }
    }
  },
  data: () => ({
    loading: false,
    loader: null,
    show: false
  }),
  methods: {
    onLoad() {
      const l = this.loader;
      this[l] = !this[l];
      console.log("Loading...");
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        console.log("done");
      }, 3000);
      this.loader = null;
    }
  }
};
</script>
